<template>
  <router-view />
</template>

<script>

export default {
  name: 'OracleAccrualGL',
};
</script>
